import { render } from "./OutboundTargets.vue?vue&type=template&id=4b7d3128&scoped=true"
import script from "./OutboundTargets.vue?vue&type=script&lang=js"
export * from "./OutboundTargets.vue?vue&type=script&lang=js"

import "./OutboundTargets.vue?vue&type=style&index=0&id=4b7d3128&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7d3128"]])

export default __exports__